import React from 'react';

const Footer = () => {
  return (
    <footer>
      <div className="wrap">
        <div className="footer-links">
          <a href="#about">about</a>
          <a href="#experience">experience</a>
          <a href="#projects">projects</a>
          <a href="#skills">skills</a>
          <a href="#contact">contact</a>
        </div>
        <a href="#top" className="back-to-top">↑ back to top</a>
        <div className="footer-meta">© 2026 Oluwaferanmi Idima · built with HTML, CSS &amp; a little JS</div>
      </div>
    </footer>
  );
};

export default Footer;